import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Stack,
  Box,
  Button,
} from "@mui/material"
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import {NavLink} from "react-router-dom";

export function GlobalMessagesWidget() {
  const newMessages = 5
  const pendingResponses = 3

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#0d2561" }}>
          Global Messages
        </Typography>

        <Stack spacing={2} mt={1}>
          <Box display="flex" alignItems="center" gap={2}>
            <ChatBubbleOutlineIcon sx={{ fontSize: 28, color: "#003087" }} />
            <Box>
              <Typography variant="h5" fontWeight={700} color="#003087">
                {newMessages}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                New Messages
              </Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <ChatBubbleOutlineIcon sx={{ fontSize: 28, color: "#f57c00" }} />
            <Box>
              <Typography variant="h5" fontWeight={700} color="#f57c00">
                {pendingResponses}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Pending Responses
              </Typography>
            </Box>
          </Box>
        </Stack>

        <Box mt={3} textAlign="right">
            <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button

                variant="text"
                size="small"
                endIcon={<ArrowForwardIcon />}
                sx={{ color: "#0d2561",p: 0, textTransform: "none" }}
            >
                Go to Messages
            </Button>
            </NavLink>

        </Box>
      </CardContent>
    </Card>
  )
}
